"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.WintersChillAbilityHandler = exports.WintersChillActorAbilityFactory = exports.WintersChillAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
const core_1 = require("../../core/effects/core");
const enums_1 = require("../../core/enums");
const Random_1 = require("../../utils/Random");
const Duration_1 = require("../../core/Duration");
const core_2 = require("../../core/vfx/core");
const LocationSelector_1 = require("../../core/vfx/LocationSelector");
class WintersChillAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.WintersChill;
        this.__typeName = "WintersChill";
    }
}
exports.WintersChillAbilityArgs = WintersChillAbilityArgs;
let WintersChillActorAbilityFactory = class WintersChillActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("WintersChill", "AllEnemies", 5);
    }
};
WintersChillActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("WintersChill")
], WintersChillActorAbilityFactory);
exports.WintersChillActorAbilityFactory = WintersChillActorAbilityFactory;
let WintersChillAbilityHandler = class WintersChillAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        const effects = [
            {
                duration: Duration_1.Duration.Turns(2),
                effect: new core_1.SlowEffectArgs(5)
            },
            {
                duration: Duration_1.Duration.Turns(2),
                effect: new core_1.MaxAttributeDecreaseEffectArgs(enums_1.AttributeType.FrostDamageImmunity, 50)
            }
        ].filter(Boolean);
        sequence = sequence.pushSequence("parallel");
        const { applyCameraVfx, resetCameraVfx } = core_2.CameraVfxStepArgs.mkSequencesFor(core_2.CameraVfxStepArgs.Alpha(.4));
        sequence.push(applyCameraVfx.mk());
        const abilitySequence = sequence.pushSequence("sequential");
        container.applyMultiAttack({
            abilityKey: "WintersChill",
            attackType: "magic",
            attackerId: ability.invokerId,
            targets: container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies).map(targetId => ({
                damages: [],
                effects: effects
                    .concat((0, Random_1.random)(1, 100) <= 50 && {
                    duration: Duration_1.Duration.Turns(1),
                    effect: new core_1.StunEffectArgs()
                })
                    .filter(Boolean)
                    .map(effect => ({
                    ...effect,
                    targetId
                })),
                jitter: 0,
                targetId
            })),
            sequence: abilitySequence,
            onHit(sequence, target) {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet"), "IcePillar"));
            },
            onMiss(sequence, target) {
                sequence.push(new core_2.InstantVfxStepArgs(new LocationSelector_1.ActorVfxLocationSelector(target.targetId, "feet", "behind"), "IcePillar"));
            },
        });
        abilitySequence.push(resetCameraVfx.mk());
    }
};
WintersChillAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.WintersChill)
], WintersChillAbilityHandler);
exports.WintersChillAbilityHandler = WintersChillAbilityHandler;
